import { cn } from '@/components/ui/cn';
import { Box } from '@/components/ui/layout';
import layoutStyles from './public-auth-shell.layout.module.css';

import type { PropsWithChildren } from 'react';

import { OnboardingLogoHeader } from '@/components/layout/onboarding-logo-header';

import { GuestLandingTextPanel } from './guest-landing-text-panel';

type PublicAuthShellProps = PropsWithChildren<{
  title: string;
}>;

export function PublicAuthShell({ title, children }: PublicAuthShellProps) {
  return (
    <Box className={cn(layoutStyles.layout1)}>
      <OnboardingLogoHeader />
      <Box as="main" className={cn(layoutStyles.layout2)}>
        {/*
         * Keep the public auth pages on an explicit flex shell. The previous
         * Grid2 item/container nesting sized each column to its content height
         * under SSR, which left the login/register pages visually collapsed.
         */}
        <GuestLandingTextPanel title={title} />
        <Box className={cn(layoutStyles.layout3)}>{children}</Box>
      </Box>
    </Box>
  );
}
